import React from 'react'
import EventFormContent from './EventFormContent'

export default function StepOneDetails({ step, formData, errorFields, onChange }) {
  return (
    <div className={`${step !== 0 ? 'hidden' : 'block'} md:block`}>
      <fieldset className="form-fieldset">
        <legend className="form-legend">Event Details</legend>
        <p className="text-sm text-muted mb-4">
          Provide a concise event title and a detailed description. Include date, time, location, and any special instructions or requirements.
        </p>
        <EventFormContent formData={formData} onChange={onChange} errorFields={errorFields} />
      </fieldset>
    </div>
  )
}